import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import useVenue from "../../hooks/useVenue";

import * as styles from "./styles.module.scss";

const BoardDivider = ({ small, thin }) => {
  const { isBexley, isEltham } = useVenue();
  const className = classNames(styles.boardDivider, {
    [styles.bexley]: isBexley,
    [styles.eltham]: isEltham,
    [styles.small]: small,
    [styles.thin]: thin,
  });

  return <div className={className} />;
};

BoardDivider.propTypes = {
  small: PropTypes.bool,
  thin: PropTypes.bool,
};

export default BoardDivider;
